export enum StatusCart {
    CartAnonymous = -1,
    CartPending = 0,
    CartPayed = 1,
    CartExpired = 2,
    CartCancelled = 3,
    CartToActivate = 4
  }
